export default {
    meta: {
        title: '创建沟通纪要',
        url: '/standardstore/tasklist',
        urlName: '标准版拓店-拓店任务'
    }
};
